export interface CSVExportOptions {
  filename?: string;
  headers?: string[];
  data: any[];
  fieldMapping?: Record<string, string>;
}

export const exportToCSV = (options: CSVExportOptions) => {
  const { filename = "export.csv", headers, data, fieldMapping } = options;

  if (!data || data.length === 0) {
    console.warn("No data to export");
    return;
  }

  // default headers
  const defaultHeaders = [
    "No.",
    "Property Code",
    "Property Name",
    "Category",
    "Type",
    "Status",
    "Owner",
    "City",
    "District",
    "Commune",
    "Price",
    "Size",
    "Land Area",
    "Bedrooms",
    "Bathrooms",
    "Popular Place",
    "Features",
    "Available",
    "Hot Property",
    "Sold/Rented At",
    "YouTube Link",
    "Created At",
    "Google Map Link",
    "Description",
  ];

  const defaultFieldMapping = {
    property_code: "Property Code",
    property_name: "Property Name",
    "property_category.name": "Category",
    "property_type.name": "Type",
    property_status_display: "Status",
    "owner.name": "Owner",
    "city.name": "City",
    "district.name": "District",
    "commune.name": "Commune",
    price: "Price",
    size: "Size",
    land_area: "Land Area",
    bedrooms: "Bedrooms",
    bathrooms: "Bathrooms",
    "popular_place.name": "Popular Place",
    features: "Features",
    is_available: "Available",
    is_hot: "Hot Property",
    sold_rented_at: "Sold/Rented At",
    youtube_link: "YouTube Link",
    created_at: "Created At",
    google_map_link: "Google Map Link",
    description: "Description",
  };

  const finalHeaders = headers || defaultHeaders;
  const finalFieldMapping = fieldMapping || defaultFieldMapping;

  // Convert data to CSV format
  const csvContent = [
    finalHeaders.join(","),
    ...data.map((item, index) => {
      const row: string[] = [String(index + 1)];

      Object.keys(finalFieldMapping).forEach((key) => {
        let value = "";

        if (key === "features") {
          value =
            item.features && item.features.length > 0
              ? item.features.map((f: any) => f.name).join("; ")
              : "";
        } else if (key.includes(".")) {
          const keys = key.split(".");
          let nestedValue = item;
          for (const k of keys) {
            nestedValue = nestedValue?.[k];
            if (nestedValue === undefined || nestedValue === null) break;
          }
          value = nestedValue || "";
        } else {
          value = item[key] || "";
        }

        if (typeof value === "string") {
          value = value.replace(/"/g, '""');
          if (
            value.includes(",") ||
            value.includes('"') ||
            value.includes("\n")
          ) {
            value = `"${value}"`;
          }
        }

        row.push(String(value));
      });

      return row.join(",");
    }),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export const exportPropertiesToCSV = (
  properties: any[],
  filename = "properties.csv"
) => {
  exportToCSV({
    filename,
    data: properties,
  });
};
